import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REVENUE_VICTORIOUS_PETITION_PROMOTION_ENABLED = createFcmDetails(
	'revenue_victorious_petition_promotion_enabled',
	{
		owner: 'supporters pack',
		context: 'petition page',
		description: 'Indicates whether to display a list of suggested victorious petitions on the petition page.',
		import: false,
	},
);
